import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.scrollToActive()
  }

  scrollToActive() {
    const active = this.element.querySelector(".bg-album-primary")
    if (active) {
      active.scrollIntoView({ behavior: "smooth", block: "nearest", inline: "center" })
    }
  }
}
